// src/pages/Blog/BlogPage.jsx

import React, { useState } from 'react';
import { Container, Typography, Box, Grid, Paper, Button, Chip, Divider, TextField } from '@mui/material';
import { Construction as ConstructionIcon, Schedule as ScheduleIcon, MailOutline as MailIcon, Home as HomeIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';

// Altere por env se quiser habilitar/desabilitar no build:
// REACT_APP_BLOG_MAINTENANCE=true|false
const MAINTENANCE_MODE = (process.env.REACT_APP_BLOG_MAINTENANCE ?? 'true') === 'true';

const MaintenanceView = () => {
  const [email, setEmail] = useState('');

  const handleNotify = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    // aqui você pode integrar com o backend de newsletter
    alert('Obrigado! Vamos avisá-lo quando o blog estiver no ar.'); // placeholder amigável
    setEmail('');
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Hero / Banner */}
      <Box
        sx={{
          py: 10,
          background:
            'linear-gradient(135deg, rgba(33,150,243,1) 0%, rgba(33,203,243,1) 100%)',
          color: 'primary.contrastText',
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Chip
              label="Manutenção Programada"
              color="secondary"
              sx={{ fontWeight: 'bold', mb: 2 }}
            />
            <Typography variant="h3" component="h1" gutterBottom>
              O Blog ZenKroll está a ficar ainda melhor 🚧
            </Typography>
            <Typography variant="h6" sx={{ opacity: 0.95 }}>
              Estamos a preparar uma nova experiência com conteúdos de qualidade
              — voltamos em breve.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Card principal */}
      <Container maxWidth="md" sx={{ mt: -6, mb: 6, flex: 1 }}>
        <Paper
          elevation={6}
          sx={{
            p: 5,
            borderRadius: 3,
            backgroundColor: 'background.paper',
            backdropFilter: 'blur(6px)',
          }}
        >
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  height: 160,
                  width: 160,
                  mx: 'auto',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'primary.light',
                }}
              >
                <ConstructionIcon sx={{ fontSize: 80, color: 'primary.main' }} />
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <Typography variant="h5" gutterBottom>
                O que está a acontecer?
              </Typography>
              <Typography variant="body1" color="text.secondary" paragraph>
                Estamos a realizar melhorias de performance, segurança e UX, além de preparar novas
                categorias e recursos editoriais. O acesso voltará assim que finalizarmos os ajustes.
              </Typography>

              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', my: 2 }}>
                <Chip icon={<ScheduleIcon />} label="Downtime curto" />
                <Chip icon={<RefreshIcon />} label="Atualizações em tempo real" />
                <Chip icon={<MailIcon />} label="Avise-me quando voltar" color="primary" />
              </Box>

              {/* Mini formulário de aviso */}
              <Box component="form" onSubmit={handleNotify} sx={{ display: 'flex', gap: 1, mt: 2 }}>
                <TextField
                  type="email"
                  placeholder="Seu e-mail para receber aviso"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  size="small"
                  fullWidth
                />
                <Button type="submit" variant="contained" color="primary">
                  Enviar
                </Button>
              </Box>

              <Divider sx={{ my: 3 }} />

              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<HomeIcon />}
                  component={Link}
                  to="/"
                >
                  Voltar ao Início
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<MailIcon />}
                  component={Link}
                  to="/suporte"
                >
                  Contactar Suporte
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>

      <Footer />
    </Box>
  );
};

const BlogPage = () => {
  // Mantemos o gate para o futuro; por ora, sempre mostra a manutenção
  if (MAINTENANCE_MODE) {
    return <MaintenanceView />;
  }

  // Caso queira reativar o conteúdo antigo, pode implementar aqui.
  return <MaintenanceView />; // fallback seguro
};

export default BlogPage;
